import Link from 'next/link'

import styled, { css } from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  padding,
  PaddingProps,
} from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

export type ContainerProps = {
  isFirst?: boolean
}

const containerIsFirstCss = ({ isFirst }: ContainerProps) =>
  isFirst &&
  css`
    border-top: 1px solid;

    @media screen and (min-width: ${themeGet('breakpoints.5')}) {
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
    }
  `

const shouldForwardProp = (prop: string | number) => {
  return ![...DIV_SHOULD_FORWARD_PROP, 'isFirst', 'isLast'].includes(
    String(prop),
  )
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & PaddingProps & ContainerProps>`
  display: flex;
  width: 100%;
  gap: ${themeGet('space.11')}px;
  background: linear-gradient(
    180deg,
    rgba(37, 54, 90, 0) 50%,
    rgba(37, 54, 90, 0.03) 100%
  );
  overflow: hidden;

  @media screen and (min-width: ${themeGet('breakpoints.5')}) {
    border-radius: 40px;
  }

  ${containerIsFirstCss}

  ${flexDirection}
  ${padding}
`

export const BenefitHolder = styled.div`
  display: flex;
  color: ${themeGet('colors.success.default')};
  gap: ${themeGet('space.4')}px;

  > svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
`

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.3')}px;
  text-decoration: none;

  > span,
  svg {
    color: ${themeGet('colors.text.link')};
  }

  &:hover {
    > span,
    svg {
      color: ${themeGet('colors.text.linkHover')};
    }
  }

  > svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
`

export const LogoHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  max-width: 100px;

  > img {
    position: relative !important;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`

export const ImageHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  > img {
    position: relative !important;
    object-fit: contain;
    object-position: right;
    width: 100%;
    height: 100%;
    max-width: 720px;
    max-height: 740px;
  }
`
